// 计费分类管理

import {
    HttpInsuranceOrderList,
    HttpSubmitInsuranceOrderOne,
    HttpBatchSubmitInsuranceOrder,
    HttpUpdateInsuranceOrder,
    HttpCancelInsuranceOrderOne
} from "@/service/credit";
import TableList from "@components/templates/tablelist";
import comIndex from './update'
import { mapGetters } from 'vuex';

export default {
    mixins: [TableList],
    components: {
        comIndex,
        // comRelease
    },
    data () {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            // spanTabs: { show: true },
            statusList: [
                { value: 0, label: '草稿', theme: 'error' },
                { value: 1, label: '已提交', theme: 'success' },
                { value: 2, label: '待投保', theme: 'primary' },
                { value: 3, label: '已投保', theme: 'warning' },
                { value: 4, label: '投保失败', theme: 'error' },
                { value: 5, label: '取消', theme: 'error' },
            ],
        };
    },
    methods: {
        ajaxRequest: HttpInsuranceOrderList,
        interceptRequest (params) {
            if (params.search.EQ_insuranceStatus == 6) {
                params.errorCode = 1
                delete params.search.EQ_insuranceStatus;
            }
            return params
        },
        // spanAjaxRequest:HttpReleaseNum,
        handleOperates (params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "查看",
                        width: 1100,
                        component: "comIndex",
                        querytype: 'query',
                        showalert: 1,
                        activeid: params,
                        showFooter: false,
                    };
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "insuranceUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'add':
                    this.$router.push({
                        name: "insuranceUpdate",
                        params: { type },
                    })
                    break;
                case 'edit':
                    this.$router.push({
                        name: 'insuranceUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case 'exportExcel':
                    // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/ReserveOrder/export', this.formData, 'download');
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveOrder/export", this.formData,
                        {
                            executor: "request",
                            download: true,
                            method: 'post'
                        }
                    );
                    break;
                case 'submit':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { insuranceOrderId: params },
                        title: "提交操作",
                        ajaxRequest: HttpSubmitInsuranceOrderOne
                    }
                    break;
                case 'batchsubmit':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { insuranceOrderIds: params },
                        title: "批量提交操作",
                        ajaxRequest: HttpBatchSubmitInsuranceOrder
                    }
                    break;
                case 'cancel':
                    this.operate = {
                        show: true,
                        alert: "warning",
                        params: { insuranceOrderIds: params },
                        title: "取消操作",
                        formdata: [
                            {
                                label: "备注",
                                key: 'remark',
                                tag: 'vTextarea',
                                span: 24,
                                labelWidth: 60,
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpCancelInsuranceOrderOne
                    }
                    break;
                case 'handleNew':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { insuranceOrderIds: params },
                        title: "手动更新",
                        ajaxRequest: HttpUpdateInsuranceOrder
                    }
                    break;
            }
        },
        getOperateNodeMap (row) {
            // console.log(row)
            const { id, errorCode, insuranceStatus } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: insuranceStatus == 0 || (insuranceStatus == 1 && errorCode > 0),
                params: id,
                operate: 'edit'
            }, {
                label: '提交',
                show: insuranceStatus == 0,
                params: id,
                operate: 'submit'
            }, {
                label: '取消',
                show: insuranceStatus == 0 || insuranceStatus == 1 || insuranceStatus == 4,
                params: id,
                operate: 'cancel'
            },

            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList', 'getInsuranceList']),
        insuranceList () {
            return this.getInsuranceList.filter(item => {
                return item.attach.status === 0
            })
        },
        TabsData () {
            return [
                {
                    name: "全部",
                    key: 'EQ_insuranceStatus',
                    val: null,
                    spanKey: 'allNum',
                }, {
                    name: "草稿",
                    key: 'EQ_insuranceStatus',
                    val: '0',
                    spanKey: 'draftNum',
                }, {
                    name: "已提交",
                    key: 'EQ_insuranceStatus',
                    val: '1',
                    spanKey: 'reserveNum',
                }, {
                    name: "待投保",
                    key: "EQ_insuranceStatus",
                    val: '2',
                    spanKey: 'partReserveNum',
                }, {
                    name: "投保失败",
                    key: "EQ_insuranceStatus",
                    val: '4',
                    spanKey: 'releaseNum',
                }, {
                    name: "已投保",
                    key: "EQ_insuranceStatus",
                    val: '3',
                    spanKey: 'releaseNum',
                }, {
                    name: "已取消",
                    key: "EQ_insuranceStatus",
                    val: '5',
                    spanKey: 'releaseNum',
                }, {
                    name: "异常",
                    key: "EQ_insuranceStatus",
                    val: '6',
                    spanKey: 'releaseNum',
                }
            ]
        },
        ToolsData () {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "手动更新",
                    operate: "handleNew",
                    theme: "info",
                    batch: true,
                },
                // {
                //     name: "导出",
                //     operate: "exportExcel",
                //     theme: "success",
                // },
                {
                    name: "批量提交",
                    operate: "batchsubmit",
                    theme: "info",
                    batch: true,
                    show: this.formData.search.EQ_insuranceStatus == 0
                },
            ]
        },
        SearchsData () {
            return [
                {
                    label: "平台订单号",
                    key: 'EQ_platformNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "客户单号",
                    key: 'EQ_sourceNo',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "保单号",
                    key: 'EQ_policyNumber',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "投保状态",
                    key: 'IN_insuranceStatus',
                    tag: 'vSelect',
                    options: this.statusList,
                    props: {
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: "投保产品",
                    key: 'EQ_insuranceServiceId',
                    tag: 'vSelect',
                    options: this.insuranceList,
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: "投保完成时间",
                    tag: 'vDatepicker',
                    key: 'BT_insuranceCompletionTime',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns () {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '投保单号',
                    render: (h, { row, index }) => {
                        const className = `copy_${row.reserveNo}_${index}`
                        return <div>
                            <a class={className} onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.insuranceNo || '--'}</a>
                            <div v-show={row.errorCode > 0} class="color-error">{row.errorCode == 1 ? '系统异常' : '数据异常'}</div>
                        </div>
                    }
                },
                {
                    title: '客户单号',
                    key: 'sourceNo',
                },
                {
                    title: '平台订单号',
                    key: 'platformNo',
                },
                {
                    title: '保单号',
                    key: 'policyNumber',
                }, {
                    title: '投保状态',
                    key: 'status',
                    render: (h, { row }) => this.findRenderLabel(this.statusList, row.insuranceStatus, 'label', true),
                },
                // {
                //     title: "投保组织",
                //     render: (h, { row }) => this.findRenderLabel(this.getOrgList, row.orgId)
                // },
                {
                    title: '投保产品',
                    key: 'insuranceServiceId',
                    render: (h, { row }) => this.findRenderLabel(this.insuranceList, row.insuranceServiceId)
                }, {
                    title: '投保金额(USD)',
                    key: 'insuranceAmount',
                }, {
                    title: '创建时间',
                    key: 'createdAt',
                }, {
                    title: '投保完成时间',
                    key: 'insuranceCompletionTime',
                }];
        },
    },
};




